var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIll2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 831 830",
    style: {
      enableBackground: "new 0 0 831 830"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:7.000000e-02;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.4;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st2{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st3{fill:#F2994A;}\n\t.st4{opacity:7.000000e-02;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st5{opacity:0.3;fill:url(#SVGID_4_);enable-background:new    ;}\n\t.st6{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:7.000000e-02;fill:url(#SVGID_5_);enable-background:new    ;}\n\t.st8{opacity:0.3;fill:url(#SVGID_6_);enable-background:new    ;}\n\t.st9{opacity:0.3;fill:url(#SVGID_7_);enable-background:new    ;}\n\t.st10{fill:#F2C94C;}\n\t.st11{opacity:0.2;fill:url(#SVGID_8_);enable-background:new    ;}\n\t.st12{opacity:0.2;fill:url(#SVGID_9_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 813.0007,
    y1: 121.0236,
    x2: 503.5727,
    y2: 414.5226,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755.2,350c0,4.5-0.1,9-0.4,13.2c43,32.7,76.1,102.8,76.1,164.5c0,67.2-39.3,98.9-87.8,70.9 c-0.1-0.1-0.2-0.1-0.3-0.2L438.1,422.7c-0.1-0.1-0.2-0.1-0.4-0.2C383.2,391,339,304.3,339,228.8c0-70.7,38.8-106.6,88.5-84.9 c6.1-48.5,38.6-69.4,77.8-46.7c18.8,10.9,36.1,30,49.6,53c19.6-29.1,53-36.5,90.8-14.7C706.2,170.3,755.2,266.4,755.2,350z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.9946,
    y1: 169.0287,
    x2: 453.5677,
    y2: 462.5277,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M705.2,398c0,4.5-0.1,9-0.4,13.2c43,32.7,76.1,102.8,76.1,164.5c0,67.2-39.3,98.9-87.8,70.9 c-0.1-0.1-0.2-0.1-0.3-0.2L388.1,470.7c-0.1-0.1-0.2-0.1-0.4-0.2C333.2,439,289,352.3,289,276.8c0-70.7,38.8-106.6,88.5-84.9 c6.1-48.5,38.6-69.4,77.8-46.7c18.8,10.9,36.1,30,49.6,53c19.6-29.1,53-36.5,90.8-14.7C656.2,218.3,705.2,314.4,705.2,398z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.8,483.6l-46.4-26.8v-15.7l46.4,26.8c3.8,2.2,9.3,6.6,14,13.4c5.1,7.3,8.7,16.5,8.7,26.5 c0,11-2.8,17.3-8.2,19.1c-5,1.7-10.9-1.2-14.6-3.3l-19.1-11l-0.1-0.1c-1.6-1-4.2-1.9-6.3-1.3c-1.7,0.5-3.6,2.2-3.6,8.3 s1.9,9.9,3.5,12.1c2,2.8,4.6,4.8,6.2,5.6l0.2,0.1l58.3,33.7v15.7l-58-33.5c-4-2.1-9.7-6.5-14.7-13.5c-5.4-7.6-9.2-17.3-9.1-28.1 c0-10.7,3.7-16.2,9.1-17.7c5-1.4,10.7,0.6,14.7,3.1l18.9,10.9c2.7,1.6,4.8,2.3,6.1,1.8c1-0.3,3-1.8,3-9.8c0-5.1-1.7-8.5-3.2-10.8 C226.8,486.5,224.3,484.5,222.8,483.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.4,452.9c0,12.9-7.6,19-16.9,13.7c-9.3-5.4-16.9-20.2-16.9-33.2c0-12.9,7.6-19,16.9-13.7 C178.8,425.1,186.4,440,186.4,452.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.4,591.9c0,12.9-7.6,19-16.9,13.7c-9.3-5.4-16.9-20.2-16.9-33.2c0-12.9,7.6-19,16.9-13.7 C277.8,564.1,285.4,579,285.4,591.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.1014,
    y1: 234.389,
    x2: 520.2755,
    y2: 515.108,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.3,259.7l299.9,173.1v158.7l-300-173.1L365.3,259.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.0515,
    y1: 254.3909,
    x2: 480.2255,
    y2: 535.11,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,279.7l299.9,173.1v158.7L325.2,438.4V279.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.1,374.2c0,12.8,7.6,27.5,16.9,32.9s16.9-0.6,16.9-13.4s-7.6-27.5-16.9-32.9 C359.7,355.4,352.1,361.4,352.1,374.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.4,398.9c0,5.9,3.5,12.8,7.9,15.3c4.3,2.5,7.8-0.3,7.8-6.2c0-5.9-3.5-12.8-7.9-15.3 C397.9,390.2,394.4,393,394.4,398.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M418.5,412.8c0,5.9,3.5,12.8,7.9,15.3c4.3,2.5,7.8-0.3,7.8-6.2c0-5.9-3.5-12.8-7.9-15.3 C422,404.1,418.5,406.9,418.5,412.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M549.4,439.8v90.3l-11.8-6.8V433L549.4,439.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M575.2,454.8v90.3l-11.8-6.8V448L575.2,454.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M601.1,469.8v90.3l-11.8-6.8V463L601.1,469.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.0528,
    y1: 451.3241,
    x2: 520.2268,
    y2: 732.0421,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M365.2,476.6l299.9,173.1v158.7L365.2,635.3V476.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.0528,
    y1: 472.3239,
    x2: 480.2268,
    y2: 753.0421,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M325.2,497.6l299.9,173.1v158.7L325.2,656.3V497.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.1,592.1c0,12.8,7.6,27.5,16.9,32.9s16.9-0.6,16.9-13.4c0-12.8-7.6-27.5-16.9-32.9 C359.7,573.3,352.1,579.3,352.1,592.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.4,616.9c0,5.9,3.5,12.8,7.9,15.3c4.3,2.5,7.8-0.3,7.8-6.2s-3.5-12.8-7.9-15.3 C397.9,608.2,394.4,610.9,394.4,616.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M418.4,630.8c0,5.9,3.5,12.8,7.9,15.3c4.3,2.5,7.8-0.3,7.8-6.2s-3.5-12.8-7.9-15.3 C421.9,622,418.4,624.8,418.4,630.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M549.4,660.8v90.3l-11.8-6.8V654L549.4,660.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M575.2,675.8v90.3l-11.8-6.8V669L575.2,675.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M601.1,690.8v90.3l-11.8-6.8V684L601.1,690.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.8562,
    y1: 37.0504,
    x2: 99.9459,
    y2: 324.4902,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.9,44.6l186.9,107.9v346.3l-186.9-108V44.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.3,170c0,17.3-10,25.5-22.3,18.3s-22.3-27-22.3-44.3s10-25.5,22.3-18.3S174.3,152.7,174.3,170z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M152,202.2c-19.9-11.6-36.3-0.7-39.2,24.3c-0.5,4.3,2.8,10.1,6.8,12.4l64.9,37.9c4,2.3,7.3,0.5,6.8-4.5 C188.3,243.8,171.8,213.8,152,202.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4,269.2l111.4,64.3v13.6L96.4,282.8V269.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.7,302.7l88.3,50.9v13.6l-88.3-50.9V302.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M130.2,359.9l-130-75.1v38.7l130,75.1V359.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.8885,
    y1: 17.7859,
    x2: 255.1676,
    y2: 46.0601,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M286.1,0.7l27.8,54.6c3.8,7.5,3.2,15-1.4,16.8c-4.6,1.8-11.4-2.9-15.2-10.4L297,61v60.6 c0,6.9-4.8,9.7-10.8,6.3c-6-3.5-10.8-11.8-10.8-18.7V48.6l-0.3,0.3c-3.8,3.1-10.7-0.1-15.2-7.2c-4.6-7.1-5.2-15.3-1.4-18.4 L286.1,0.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.255,
    y1: 713.8456,
    x2: 316.976,
    y2: 685.5716,
    gradientTransform: "matrix(1 0 0 1 0 38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.1,806.9l-27.8-54.6c-3.8-7.5-3.2-15,1.4-16.8c4.6-1.8,11.4,2.9,15.2,10.4l0.3,0.7V686 c0-6.9,4.8-9.7,10.8-6.3c6,3.5,10.8,11.8,10.8,18.7V759l0.3-0.3c3.8-3.1,10.7,0.1,15.2,7.2c4.6,7.1,5.2,15.3,1.4,18.4L286.1,806.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIll2);
export default __webpack_public_path__ + "static/media/ill2.b5f633087cbed10772355d5ab59841b0.svg";
export { ForwardRef as ReactComponent };